'use strict';
/**
 * Dialog
 *
 * 削除などの確認を行うための Module です。
 * alertify.js の通知機能を利用して画面にダイアログを出します。
 *
 * - alert
 * - confirm
 *
 * @example
 * confirm({
     *      text: 'my alert title',
     *      okCallback: function() {},
     *      cancelCallback: function() {}
     * });
 */

const i18n = require('i18next');
const Alertify = require('alertify.js');

const alert = function(params) {
    Alertify.alert(params.text, params.okCallback, params.cancelCallback);
};

const confirm = function(params) {
    Alertify
        .okBtn(i18n.t('module/word:ok'))
        .cancelBtn(i18n.t('module/word:cancel'))
        .confirm(params.text, params.okCallback, params.cancelCallback);
};

module.exports = {
    alert: alert,
    confirm: confirm
};



// WEBPACK FOOTER //
// ./common/util/dialog.js